import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';

const UserRolesIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/user-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'user_roles_index',
          component: UserRolesIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.USER_ROLES,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
